import React,{useState} from 'react';
import { withRouter, useHistory } from 'react-router-dom';

import {
    Box, Grid,
    Button, IconButton,
    TextField, Select, MenuItem,
    FormHelperText, FormControl, FormControlLabel,
    RadioGroup, Radio, Checkbox,
    Dialog, DialogTitle, DialogContent,
    InputAdornment
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { useStyles } from "../../styles";
import * as Icons from "../../iconComponents";
import { useForm, Controller } from "react-hook-form";
import { forEach, isNumber } from 'lodash';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  TimePicker,
  DateTimePicker,
  KeyboardDateTimePicker
} from '@material-ui/pickers';
import IndexedDb from '../../IndexedDb';
import Observations from '../Observations';
import { el } from 'date-fns/locale';

const defaultValues = {
    date: new Date(),
    time: "",
    resp_rate: "",
    bp_dia: "",
    bp_sys: "",
    heart_rate: "",
    temperature: "",
    spo2: "",
    o2_flow_rate: "0",
    bgl: "",
    consciousness: "",
    pain_score: "0",
    pain_score_assessment: "1",
};

 const Popup: React.FC<any> = ({ popState, setPopState, itemIndex, itemAppend, itemRemove, itemValue, itemSetValue,items,observationdata,setchartwidth,chartwidth,observationdatas }): JSX.Element => {
    const classes = useStyles();
    const[Indexdb,setIndexdb]=useState("");
    const {
        trigger: ob_trigger,
        errors: ob_errors,
        control: ob_control,
        getValues: ob_getValues,
        reset: ob_reset
    } = useForm({
        defaultValues: defaultValues,
    });
    const [Observationdate, setObservationdate] = useState(new Date());
    const [Observationtime, setObservationtime] = useState(new Date());

    const [ObservationResprate, setObservationResprate] = useState("");
    const [ObservationBPDia, setObservationBPDia] = useState("");
    const [ObservationBPSys, setObservationBPSys] = useState("");
    const [ObservationHR, setObservationHR] = useState("");
    const [ObservationTemp, setObservationTemp] = useState("");
    const [ObservationtSP, setObservationSP] = useState("");
    const [ObservationO2, setObservationO2] = useState("");
    const [ObservationBGL, setObservationBGL] = useState("");
    const [ObservationCon, setObservationCon] = useState("");
    const [ObservationPS, setObservationPS] = useState("");
    const [ObservationPA, setObservationPA] = useState("");
    const [Key, setKey] = useState("");
    const[Item,setItem]=useState(0);
    const [radioDisabled, setRadioDisabled] = React.useState(false);
    const [painScorePopup, setPainScorePopup] = React.useState(false);
    
    React.useEffect(() => {
        //
    }, [])
    React.useEffect(() => {
        let db:any = null;
        db = localStorage.getItem("PatientDB");
        setIndexdb(db);
        if(popState)
        {
            handleEdit();
        }
        else
        {
            ob_reset(defaultValues);
        }
        if(itemValue == null)
        {   
            clear();
            getitem();
        }
       
    }, [popState])
    
    const handleClose = (): void => {
        setPopState(!popState);
       
    }
    const handleEdit = (): void => {
        if(isNumber(itemIndex) && itemValue)
        {
            let value: any = {};
            
            if(itemValue!=null)
            {
                setObservationdate(itemValue.date);
                setObservationtime(itemValue.time);
                setObservationResprate(itemValue.resprate);
                setObservationBPDia(itemValue.bpdia);
                setObservationBPSys(itemValue.bpsys);
                setObservationTemp(itemValue.temp);
                setObservationHR(itemValue.heartrate);
                setObservationSP(itemValue.sp);
                setObservationO2(itemValue.fr);
                setObservationBGL(itemValue.bgl);
                setObservationCon(itemValue.conc);
                setObservationPS(itemValue.ps);
                setObservationPA(itemValue.pa);
                setKey(itemValue.Key)
            }
            else
            {
                clear();
            }
            for(let key in defaultValues)
            {
                if(itemValue.hasOwnProperty(key))
                {
                    value[key] = itemValue[key];
                }
            }
            ob_reset(value);
        }
    }
    const handleDelete = async() => {
        if (window.confirm('Are you sure you want to delete this observation?'))
        {
            if(isNumber(itemIndex))
            {         
                itemRemove(itemIndex);
                const indexedDb = new IndexedDb(Indexdb);
                await indexedDb.createObjectStore(indexedDb.patientcarerecord);
                await indexedDb.deleteValue('Observation', Key);
                let val = await indexedDb.getAllValue('Observation');
                if(val.length >1)
                {
                    var s = chartwidth;  
                    setchartwidth(s - 90);
                }   
                observationdata();
                observationdatas();
                handleClose();       
            }   
        }
    }
    const clear =()=>{
        setObservationdate(new Date());
        setObservationtime(new Date());
        setObservationResprate("");
        setObservationBPDia("");
        setObservationBPSys("");
        setObservationTemp("");
        setObservationHR("");
        setObservationSP("");
        setObservationO2("");
        setObservationBGL("");
        setObservationCon("");
        setObservationPS("");
        setObservationPA("");
    }
    const onSubmit = async () => {
        let Key:number=0;  
        const validate = await ob_trigger();
        if(validate)
        {
            let values = await ob_getValues();
            if(values)
            {               
                if(isNumber(itemIndex))
                {
                    await itemSetValue(`observations[${itemIndex}]`, values);
                }
                // else
                // {
                //     await itemAppend(Observationtime);
                // }                  
                if(itemValue!=null)
                {
                 if(Indexdb!=null || Indexdb !="")
                {
                    const indexedDb = new IndexedDb(Indexdb);
                    await indexedDb.createObjectStore(indexedDb.patientcarerecord);
                    await indexedDb.deleteValue('Observation', itemValue.Key);
                    let vals = await indexedDb.getAllValue('Observation');
                    let res = vals.length;   
                    items=res;                    
                    await indexedDb.putBulkValue('Observation',[{ date:Observationdate,time:Observationtime,heartrate:ObservationHR
                     ,bpsys:ObservationBPSys,bpdia:ObservationBPDia,resprate:ObservationResprate,temp:ObservationTemp,
                     sp:ObservationtSP,fr:ObservationO2,bgl:ObservationBGL,conc:ObservationCon,
                    ps:ObservationPS,pa:ObservationPA,Key:itemValue.Key }],itemValue.Key);
                    
                    let val = await indexedDb.getAllValue('Observation');                           
                    observationdata();
                    observationdatas();
                    itemRemove();
                    for(let i=0;i<val.length;i++)
                    {                    
                        if(val[i].Key.includes("item"))
                        {                     
                            let res = val[i].value;
                            itemAppend(res);                                                                  
                        }
                    }
                   
                }
                }   
                else
                {                    
                if(Indexdb!=null || Indexdb !="")
                {
                    
                    const indexedDb = new IndexedDb(Indexdb);
                    await indexedDb.createObjectStore(indexedDb.patientcarerecord);
                    let vals = await indexedDb.getAllValue('Observation');
                    var res =null;
                    var items = 0;
                    let itemval:any=[];
                    for(let i=0;i<vals.length;i++)
                    {                    
                        if(vals[i].Key.includes("item"))
                        {                                                       
                            res = vals[i].Key;                                                     
                            var keyval = res.split("item")[1]; 
                            itemval.push(Number(keyval));
                                                                                                                       
                        }
                    }                  
                    if(itemval.length >0)
                    {
                        items = (Math.max(...itemval) + 1);
                    }                                                   
                    await indexedDb.putBulkValue('Observation',[{ date:Observationdate,time:Observationtime,heartrate:ObservationHR
                     ,bpsys:ObservationBPSys,bpdia:ObservationBPDia,resprate:ObservationResprate,temp:ObservationTemp,
                     sp:ObservationtSP,fr:ObservationO2,bgl:ObservationBGL,conc:ObservationCon,
                    ps:ObservationPS,pa:ObservationPA,Key:'item'+items}],'item'+items);                  
                    let val = await indexedDb.getAllValue('Observation');
                    if(val.length >1)
                    {
                        var s = chartwidth;  
                        setchartwidth(s + 90);
                    }                      
                    observationdata();
                    observationdatas();
                    itemRemove();
                    for(let i=0;i<val.length;i++)
                    {                    
                        if(val[i].Key.includes("item"))
                        {
                            
                            let res = val[i].value;
                            itemAppend(res);                                                                  
                        }
                    }
                }
            }
            //Updatepainscore();
                handleClose();
            }        
           
        }
    }
    const getitem= async ()=>{
        const indexedDb = new IndexedDb(Indexdb);
        await indexedDb.createObjectStore(indexedDb.patientcarerecord);
        let val = await indexedDb.getAllValue('Observation');
        for(let i=0;i<val.length;i++)
        {
            if(val[i].Key.includes("item"))
            {
                   let res = val[i].value.pa;     
                    if(res !==null)
                    {
                        setObservationPA(res)                                               
                    }    
                // if(val.filter((x:any) =>x.Key != "PatientWeight").length == 0)
                // {
                //     if(!itemValue)
                //     {                  
                //     }                   
                // } 
                // else
                // {
                //     let res = val[i].value;     
                //     if(res.pa !==null)
                //     {
                //         setObservationPA(res.pa)                        
                //         return
                //     }    
                // }
                  
            }
            // if(val.filter((x:any) =>x.Key != "PatientWeight").length == 0)
            // {
            //     if(!itemValue)
            //     {
            //         setRadioDisabled(false)
            //     }                   
            // } 
        }
    }
    const handleDateChange = (date:any,Key:any) => {
        //console.log(date);
        if(Key == "Observationdate")
        {
            setObservationdate(date);
        }
        if(Key == "Observationtime")
        {
            setObservationtime(date);
        }    
    };
    const Painscoremessge = async(value:any)=>{
        var  Message = false;
        const indexedDb = new IndexedDb(Indexdb);
        await indexedDb.createObjectStore(indexedDb.patientcarerecord);
        let vals = await indexedDb.getAllValue('Observation');
        for(var i = 0;i<vals.length;i++)
        {            
            if(vals[i].Key.includes("item"))
            {
                if(vals.filter((x:any) =>x.Key != "PatientWeight").length == 1)
                {                   
                    if(!itemValue && vals[i].value.pa !== "")
                    {
                        Message = true;
                    }                   
                }   
                if(vals.filter((x:any) =>x.Key != "PatientWeight").length >= 2)
                {
                    if(vals[i].value.pa !== "")
                    {
                        Message = true; 
                    }
                                                    
                }               
            }
        }
        if(value)
        {
            if(!Message)
            {
                setObservationPA(value)
            }
            else
            {
                if (window.confirm('All pain observations in a PCR should be assessed the same way. If you change this field, it will also be changed on existing observations. Are you sure you want to continue?'))
                {
                    setObservationPA(value)
                }     
            }
           
        }
       else
       {
        setObservationPA("")
       }    
      }
      const Updatepainscore = async()=>{
        if(ObservationPS)
        {
        const indexedDb = new IndexedDb(Indexdb);
        await indexedDb.createObjectStore(indexedDb.patientcarerecord);
        let vals = await indexedDb.getAllValue('Observation');
        for(var i = 0;i<vals.length;i++)
        {
            if(vals[i].Key.includes("item"))
            {
                //await indexedDb.deleteValue('Observation', vals[i].Key);
                await indexedDb.putBulkValue('Observation',[{ date: vals[i].value.date,time:vals[i].value.time,
                    heartrate:vals[i].value.heartrate
                    ,bpsys:vals[i].value.bpsys,
                    bpdia:vals[i].value.bpdia,
                    resprate:vals[i].value.resprate,
                    temp:vals[i].value.temp,
                    sp:vals[i].value.sp,
                    fr:vals[i].value.fr,
                    bgl:vals[i].value.bgl,
                    conc:vals[i].value.conc,
                   ps:ObservationPS,pa:vals[i].value.pa  ,Key:vals[i].value.Key }],vals[i].value.Key);
                   
            }
        }
        }
    }
    
    const choosePainScore = (value: any): void => {
        //setValue("pain_score", value);
        setObservationPS(value);
        setPainScorePopup(false);
        if(ObservationPA == null || ObservationPA == "")setObservationPA("1")
    }
    
    return (
        <>
            {popState && (<>
            <Dialog
                open={popState}
                onClose={handleClose}
                className={classes.pcrDialog}
                fullScreen
            >
                <DialogTitle disableTypography>
                    Observation
                    <IconButton className={"closeButton"} onClick={handleClose}>
                        <Icons.CloseIcon />
                    </IconButton>
                    {isNumber(itemIndex) && (<>
                    <IconButton className={"button2"} onClick={handleDelete}>
                        <Icons.DeleteIcon />
                    </IconButton>
                    </>)}
                </DialogTitle>
                <DialogContent dividers className={classes.observationPopup}>
                    <Grid container className={`${classes.formContainer} gridSection`} spacing={3}>
                        <Grid item xs={12} sm={12}>
                            <div className={classes.formControlLabel}>
                                <Icons.RequiredIcon />DATE & TIME
                            </div>
                            <Grid container spacing={3}>
                                <Grid item xs={6} sm={3}>
                                    <Controller
                                        control={ob_control}
                                        name="date"
                                        defaultValue={Observationdate}
                                        render={props => (
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDateTimePicker
                                                    inputVariant="outlined"
                                                    //label="Material Date Picker"
                                                    value={Observationdate}
                                                    format="dd/MM/yyyy HH:mm:ss"
                                                    cancelLabel={false}
                                                    okLabel={false}
                                                    autoOk={true}
                                                    onChange={(e) => {
                                                        props.onChange(e);
                                                        handleDateChange(e, "Observationdate");
                                                    }}
                                                    defaultValue={Observationdate}
                                                    //inputProps={{ classes: { root: classes.textFieldInput } }}                                                                                                        
                                                    InputProps={{ classes: { root: classes.textFieldInput } }}
                                                    error={!!ob_errors.date}
                                                    helperText={ob_errors.date ? ob_errors.date.message : ""}
                                                    keyboardIcon={<Icons.DatePickerIcon />}
                                                />
                                            </MuiPickersUtilsProvider>
                                        )}
                                        rules={{
                                            required: "Date and Time is required",
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container className={`${classes.formContainer} gridSection`} spacing={3}>
                        <Grid item xs={6} sm={3}>
                            <div className={classes.formControlLabel}>
                                RESP. RATE (BRPM)
                            </div>
                            <Controller
                                control={ob_control}
                                name="resp_rate"
                                defaultValue={ObservationResprate}
                                render={({ onChange, onBlur, value, name }) => (
                                    <TextField
                                        variant='outlined'
                                        type="number"                                                              
                                        defaultValue={ObservationResprate}                            
                                        onBlur={(e) => {
                                           setObservationResprate(e.target.value);
                                        }}
                                        value={ObservationResprate}
                                        onChange={e => {   
                                            let val = e.target.value;
                                            if(Number(val)>=0 && !val.includes("."))
                                            {
                                                setObservationResprate(val);
                                            }                                                                            
                                        }}
                                        InputProps={{ classes: { root: classes.textFieldInput } }}
                                        inputProps={{ min: 0 }}       
                                        error={!!ob_errors.resp_rate}
                                        helperText={ob_errors.resp_rate ? ob_errors.resp_rate.message : ""}
                                    />
                                )}
                                rules={{
                                    
                                    //required: "This field is required",
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <div className={classes.formControlLabel}>
                                BP (MMHG)
                            </div>
                            <Grid container spacing={0} alignItems={"center"}>
                                <Grid item xs={5} sm={5}>
                                <Controller
                                        control={ob_control}
                                        name="bp_sys"
                                        defaultValue={ObservationBPSys}
                                        render={props => (
                                            <TextField
                                                variant='outlined'
                                                defaultValue={ObservationBPSys}
                                                onBlur={(e) => {
                                                    setObservationBPSys(e.target.value);
                                                 }}
                                                 value={ObservationBPSys}
                                                 onChange={e => {   
                                                    let val = e.target.value;
                                                    if(Number(val)>=0 && !val.includes("."))
                                                    {
                                                        setObservationBPSys(val);
                                                    }                                                                            
                                                }}   
                                                InputProps={{ classes: { root: classes.textFieldInput } }}
                                                error={!!ob_errors.bp_sys}
                                                helperText={ob_errors.bp_sys ? ob_errors.bp_sys.message : ""}
                                                placeholder="Sys"
                                                type="number" 
                                            />
                                        )}
                                        rules={{
                                            //required: "This field is required",
                                        }}
                                    />                                   
                                </Grid>
                                <Grid item xs={"auto"} sm={"auto"}>
                                    <Icons.FieldSlashIcon />
                                </Grid>
                                <Grid item xs={5} sm={5}>
                                <Controller
                                        control={ob_control}
                                        name="bp_dia"
                                        defaultValue={ObservationBPDia}
                                        render={props => (
                                            <TextField
                                                variant='outlined'
                                                defaultValue={ObservationBPDia}
                                                onBlur={(e) => {
                                                    setObservationBPDia(e.target.value);
                                                 }}
                                                 value={ObservationBPDia}
                                                 onChange={e => {   
                                                     let val = e.target.value;
                                                     if(Number(val)>=0 && !val.includes("."))
                                                     {
                                                        setObservationBPDia(val);
                                                     }                                                                            
                                                 }}   
                                                InputProps={{ classes: { root: classes.textFieldInput } }}
                                                error={!!ob_errors.bp_dia}
                                                helperText={ob_errors.bp_dia ? ob_errors.bp_dia.message : ""}
                                                placeholder="Dia"
                                                type="number" 
                                            />
                                        )}
                                        rules={{
                                            //required: "This field is required",
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <div className={classes.formControlLabel}>
                                HEART RATE (BPM)
                            </div>
                            <Controller
                                control={ob_control}
                                name="heart_rate"
                                defaultValue={ObservationHR}
                                render={props => (
                                    <TextField
                                    defaultValue={ObservationHR}
                                        variant='outlined'
                                        onBlur={(e) => {
                                            setObservationHR(e.target.value);
                                         }}
                                         value={ObservationHR}
                                         onChange={e => {   
                                            let val = e.target.value;
                                            if(Number(val)>=0 && !val.includes("."))
                                            {
                                                setObservationHR(val);
                                            }                                                                            
                                        }}   
                                         type="number" 
                                        InputProps={{ classes: { root: classes.textFieldInput } }}
                                        error={!!ob_errors.heart_rate}
                                        helperText={ob_errors.heart_rate ? ob_errors.heart_rate.message : ""}
                                    />
                                )}
                                rules={{
                                    //required: "This field is required",
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <div className={classes.formControlLabel}>
                                TEMPERATURE (C)
                            </div>
                            <Controller
                                control={ob_control}
                                name="temperature"
                                defaultValue={ObservationTemp}
                                render={props => (
                                    <TextField
                                        variant='outlined'
                                        defaultValue={ObservationTemp}
                                        onBlur={(e) => {
                                            setObservationTemp(e.target.value);
                                         }}
                                         value={ObservationTemp}
                                         onChange={e => {   
                                            let val = e.target.value;
                                            if(Number(val)>=0 )
                                            {
                                                setObservationTemp(val);
                                            }                                                                            
                                        }}   
                                         type="number" 
                                        InputProps={{ classes: { root: classes.textFieldInput } }}
                                        error={!!ob_errors.temperature}
                                        helperText={ob_errors.temperature ? ob_errors.temperature.message : ""}
                                    />
                                )}
                                rules={{
                                    //required: "This field is required",
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <div className={classes.formControlLabel}>
                                SPO2 (%)
                            </div>
                            <Controller
                                control={ob_control}
                                name="spo2"
                                defaultValue={ObservationtSP}
                                render={props => (
                                    <TextField
                                        variant='outlined'
                                        defaultValue={ObservationtSP}
                                        onBlur={(e) => {
                                            setObservationSP(e.target.value);
                                         }}
                                         value={ObservationtSP}
                                         onChange={e => {   
                                            let val = e.target.value;
                                            if(Number(val)>=0 && !val.includes(".")) 
                                            {
                                                setObservationSP(val);
                                            }                                                                            
                                        }}   
                                         type="number" 
                                        InputProps={{ classes: { root: classes.textFieldInput } }}
                                        error={!!ob_errors.spo2}
                                        helperText={ob_errors.spo2 ? ob_errors.spo2.message : ""}
                                    />
                                )}
                                rules={{
                                    //required: "This field is required",
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <div className={classes.formControlLabel}>
                                O2 FLOW RATE (LPM)
                            </div>
                            <Controller
                                control={ob_control}
                                name="o2_flow_rate"
                                defaultValue={ObservationO2}
                                render={props => (
                                    <TextField
                                        variant='outlined'
                                        defaultValue={ObservationO2}
                                        onBlur={(e) => {
                                            setObservationO2(e.target.value);
                                         }}
                                         value={ObservationO2}
                                         onChange={e => {   
                                            let val = e.target.value;
                                            if(Number(val)>=0 && !val.includes(".")) 
                                            {
                                                setObservationO2(val);
                                            }                                                                            
                                        }}
                                         type="number" 
                                        InputProps={{ classes: { root: classes.textFieldInput } }}
                                        error={!!ob_errors.o2_flow_rate}
                                        helperText={ob_errors.o2_flow_rate ? ob_errors.o2_flow_rate.message : ""}
                                    />
                                )}
                                rules={{
                                    //required: "This field is required",
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <div className={classes.formControlLabel}>
                                BGL (mmol/L)
                            </div>
                            <Controller
                                control={ob_control}
                                name="bgl"
                                defaultValue={ObservationBGL}
                                render={props => (
                                    <TextField
                                        variant='outlined'
                                        defaultValue={ObservationBGL}
                                        onBlur={(e) => {
                                            setObservationBGL(e.target.value);
                                         }}
                                         value={ObservationBGL}
                                         onChange={e => {   
                                            let val = e.target.value;
                                            if(Number(val)>=0) 
                                            {
                                                setObservationBGL(val);
                                            }                                                                            
                                        }}
                                         type="number" 
                                        InputProps={{ classes: { root: classes.textFieldInput } }}
                                        error={!!ob_errors.bgl}
                                        helperText={ob_errors.bgl ? ob_errors.bgl.message : ""}
                                    />
                                )}
                                rules={{
                                    //required: "This field is required",
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <div className={classes.formControlLabel}>
                                CONSCIOUSNESS
                            </div>
                            <Controller
                                control={ob_control}
                                name="consciousness"
                                defaultValue={ObservationCon}
                                render={({ onChange, onBlur, value, name }) => (
                                    <>                                  
                                        <FormControl fullWidth error={!!ob_errors.pain_score}>
                                            <div className={"consciousness"}>
                                                <IconButton
                                                    className={value === "A" ? "selected" : ""}
                                                    onClick={(e: any) => { onChange("A",setObservationCon("A")) }}
                                                >
                                                    A
                                                </IconButton>
                                                <IconButton
                                                    className={value === "V" ? "selected" : ""}
                                                    onClick={(e: any) => { onChange("V",setObservationCon("V")) }}
                                                >
                                                    V
                                                </IconButton>
                                                <IconButton
                                                    className={value === "P" ? "selected" : ""}
                                                    onClick={(e: any) => { onChange("P",setObservationCon("P")) }}
                                                >
                                                    P
                                                </IconButton>
                                                {/* {ObservationCon ?   // :
                                                // <IconButton                                                
                                                //      className={value === "" ? "selected" : "selected"}
                                                //     onClick={(e: any) => { onChange("0.5",setObservationCon("0.5")) }}                                                                                                  
                                                // >
                                                //     U
                                                // </IconButton>
                                                   }*/ }
                                                <IconButton                                                
                                                    className={value === "U" ? "selected" : ""}
                                                    onClick={(e: any) => { onChange("U",setObservationCon("U")) }}                                                                                               
                                                >
                                                    U
                                                </IconButton>
                                               
                                            </div>
                                            <FormHelperText>{ob_errors.consciousness ? ob_errors.consciousness.message : ""}</FormHelperText>
                                        </FormControl>
                                    </>
                                )}
                                rules={{
                                    //required: "This field is required",
                                }}
                            />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <div className={classes.formControlLabel}>
                                PAIN SCORE
                            </div>
                            <Controller
                                control={ob_control}
                                name="pain_score"
                                defaultValue={ObservationPS}
                                render={({ onChange, onBlur, value, name }) => (
                                    <>
                                        <FormControl fullWidth error={!!ob_errors.pain_score}>
                                            <Select
                                                name={name}
                                                defaultValue={ObservationPS}
                                                value={ObservationPS}
                                                onClick={() => setPainScorePopup(true)}
                                                onChange={(e: any) => { onChange(e,
                                                    setObservationPS(e.target.value),
                                                    ObservationPA == null || ObservationPA == ""?setObservationPA("1"):null
                                                    )}}
                                                className={classes.selectField}
                                                IconComponent={KeyboardArrowDownIcon}
                                                displayEmpty
                                                fullWidth
                                                variant="outlined"
                                                readOnly
                                            >
                                                <MenuItem value={""}>{"Choose"}</MenuItem >
                                                <MenuItem value={"0"}>{"0"}</MenuItem >
                                                <MenuItem value={"2"}>{"2"}</MenuItem >
                                                <MenuItem value={"4"}>{"4"}</MenuItem >
                                                <MenuItem value={"6"}>{"6"}</MenuItem >
                                                <MenuItem value={"8"}>{"8"}</MenuItem >
                                                <MenuItem value={"10"}>{"10"}</MenuItem >
                                            </Select>
                                            <FormHelperText>{ob_errors.pain_score ? ob_errors.pain_score.message : ""}</FormHelperText>
                                        </FormControl>
                                    </>
                                )}
                                rules={{
                                    //required: "This field is required",
                                }}
                            />
                            
                            {/* PAIN SCORE POPUP */}
                            <Dialog
                                open={painScorePopup}
                                onClose={() => setPainScorePopup(false)}
                                className={classes.painScoreDialog}
                                fullScreen
                            >
                                <DialogContent>
                                    <div className={"mainSection"}>
                                        <div className={"heading"}>
                                            Choose Pain Level
                                        </div>
                                        <div className={"body"}>
                                            <Grid container className={"bodyGrid"}>
                                                <Grid item xs={10} sm={8}>
                                                <div className={"scoreItem"} onClick={() => choosePainScore("10")}>
                                                        <div className={"iconSection"}>
                                                            <div className={"icon"}>
                                                                <Icons.PainScore10Icon />
                                                            </div>
                                                            <div className={"title"}>
                                                                Hurts<br />Worst
                                                            </div>
                                                        </div>
                                                        <div className={"scoreSection"}>
                                                            <div className={"score"}>10</div>
                                                        </div>
                                                    </div>
                                                    <div className={"scoreItem"} onClick={() => choosePainScore("8")}>
                                                        <div className={"iconSection"}>
                                                            <div className={"icon"}>
                                                                <Icons.PainScore8Icon />
                                                            </div>
                                                            <div className={"title"}>
                                                                Hurts<br />Whole Lot
                                                            </div>
                                                        </div>
                                                        <div className={"scoreSection"}>
                                                            <div className={"score"}>8</div>
                                                        </div>
                                                    </div>
                                                    <div className={"scoreItem"} onClick={() => choosePainScore("6")}>
                                                        <div className={"iconSection"}>
                                                            <div className={"icon"}>
                                                                <Icons.PainScore6Icon />
                                                            </div>
                                                            <div className={"title"}>
                                                                Hurts<br />Even More
                                                            </div>
                                                        </div>
                                                        <div className={"scoreSection"}>
                                                            <div className={"score"}>6</div>
                                                        </div>
                                                    </div>
                                                    <div className={"scoreItem"} onClick={() => choosePainScore("4")}>
                                                        <div className={"iconSection"}>
                                                            <div className={"icon"}>
                                                                <Icons.PainScore4Icon />
                                                            </div>
                                                            <div className={"title"}>
                                                                Hurts<br />Little More
                                                            </div>
                                                        </div>
                                                        <div className={"scoreSection"}>
                                                            <div className={"score"}>4</div>
                                                        </div>
                                                    </div>
                                                    <div className={"scoreItem"} onClick={() => choosePainScore("2")}>
                                                        <div className={"iconSection"}>
                                                            <div className={"icon"}>
                                                                <Icons.PainScore2Icon />
                                                            </div>
                                                            <div className={"title"}>
                                                                Hurts<br />Little Bit
                                                            </div>
                                                        </div>
                                                        <div className={"scoreSection"}>
                                                            <div className={"score"}>2</div>
                                                        </div>
                                                    </div>
                                                    <div className={"scoreItem"} onClick={() => choosePainScore("0")}>
                                                        <div className={"iconSection"}>
                                                            <div className={"icon"}>
                                                                <Icons.PainScore0Icon />
                                                            </div>
                                                            <div className={"title"}>
                                                                No Hurt
                                                            </div>
                                                        </div>
                                                        <div className={"scoreSection"}>
                                                            <div className={"score"}>0</div>
                                                        </div>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </div>
                                        <div className={"footer"}>
                                            <Grid container className={"buttons"} spacing={2}>
                                                <Grid item>
                                                    <Button className={classes.whiteBtn} type="button" onClick={() => choosePainScore("")}>
                                                        No Score
                                                    </Button>
                                                </Grid>
                                                <Grid item>
                                                    <Button className={classes.whiteBtn} type="button" onClick={() => setPainScorePopup(false)}>
                                                        Cancel
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </div>
                                    </div>
                                </DialogContent>
                            </Dialog>
                        </Grid>
                        <Grid item xs={12} sm={9}>
                            <div className={classes.formControlLabel}>
                                PAIN SCORE ASSESSMENT
                            </div>
                            <Controller
                                control={ob_control}
                                name="pain_score_assessment"
                                defaultValue={ObservationPA}
                                render={({ name, onBlur, onChange, value }) => (
                                    <>
                                        <FormControl fullWidth error={!!ob_errors.pain_score_assessment}>
                                            <RadioGroup
                                                row
                                                value={ObservationPA}
                                                defaultValue={ObservationPA}                                            
                                                onChange={(e: any) => { onChange(e,
                                                    //setObservationPA(e.target.value),                                                    
                                                    Painscoremessge(e.target.value)
                                                    )}}
                                            >
                                                <FormControlLabel
                                                    value="1"
                                                    control={<Radio />}
                                                    label="Patient Reported Score"
                                                />
                                                <FormControlLabel
                                                    value="2"
                                                    control={<Radio />}
                                                    label="Clinically Assessed Score"
                                                />
                                            </RadioGroup>
                                            <FormHelperText>{ob_errors.pain_score_assessment ? ob_errors.pain_score_assessment.message : ""}</FormHelperText>
                                        </FormControl>
                                    </>
                                )}
                                rules={{
                                    //required: "This field is required",
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid container className={`${classes.formContainer} gridSection buttons`} spacing={2}>
                        <Grid item xs={6} sm={"auto"}>
                            <Button className={classes.whiteBtn} type="button" onClick={handleClose}>
                                Cancel
                            </Button>
                        </Grid>
                        <Grid item xs={6} sm={"auto"}>
                            <Button className={classes.yellowBtn} type="button" onClick={onSubmit}>
                                Save Observation
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
            </>)}
        </>
    );
}

export default  React.memo(withRouter(Popup));